import type { IconProps } from './../../models/icon';

export function UploadIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <path
        fill={secondaryColor}
        d="M19.7139 8.57141C19.9412 8.57141 20.1593 8.66172 20.3201 8.82247C20.4807 8.9832 20.5711 9.20122 20.5711 9.42855V22.2857C20.5711 22.513 20.4807 22.7311 20.3201 22.8919C20.1593 23.0525 19.9412 23.1428 19.7139 23.1428H4.28537C4.05803 23.1428 3.84001 23.0525 3.67928 22.8919C3.51853 22.7311 3.42822 22.513 3.42822 22.2857V9.42855C3.42822 9.20122 3.51853 8.9832 3.67928 8.82247C3.84001 8.66172 4.05803 8.57141 4.28537 8.57141H19.7139Z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M17.9997 8.57141H19.7139C19.9413 8.57141 20.1593 8.66172 20.3201 8.82247C20.4807 8.9832 20.5711 9.20122 20.5711 9.42855V22.2857C20.5711 22.513 20.4807 22.7311 20.3201 22.8919C20.1593 23.0525 19.9413 23.1428 19.7139 23.1428H4.28537C4.05803 23.1428 3.84001 23.0525 3.67928 22.8919C3.51853 22.7311 3.42822 22.513 3.42822 22.2857V9.42855C3.42822 9.20122 3.51853 8.9832 3.67928 8.82247C3.84001 8.66172 4.05803 8.57141 4.28537 8.57141H5.99965"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M12 12.8572V0.857178"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M8.57129 4.28575L11.9999 0.857178L15.4284 4.28575"
      />
    </svg>
  );
}
